module.exports = __webpack_public_path__ + "static/img/1_2_1.e0b4a940.png";